import React, { createContext, useState, useContext, useEffect } from 'react';
import { adminAPI } from '../services/api';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Проверка токена при загрузке
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      // Проверяем валидность токена
      checkAuth();
    } else {
      setLoading(false);
    }
  }, []);

  const checkAuth = async () => {
    try {
      const response = await adminAPI.checkAuth();
      if (response.data.success) {
        setUser(response.data.data.user);
      }
    } catch (error) {
      console.error('Ошибка проверки авторизации:', error);
      // 🔒 SECURITY: Убран DEV bypass - всегда очищаем невалидный токен
      localStorage.removeItem('adminToken');
    } finally {
      setLoading(false);
    }
  };

  const login = async (username, password) => {
    try {
      setError(null);
      const response = await adminAPI.login({
        username,
        password
      });

      if (response && response.data && response.data.success) {
        const { token, user } = response.data.data;
        
        // Сохраняем токен
        localStorage.setItem('adminToken', token);
        
        // Сохраняем данные пользователя
        setUser(user);
        
        return { success: true };
      } else {
        const message = response?.data?.message || 'Ошибка авторизации';
        setError(message);
        return { success: false, message };
      }
    } catch (error) {
      console.error('Login error:', error);
      const message = error.response?.data?.message || 'Ошибка авторизации';
      setError(message);
      return { success: false, message };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setUser(null);
    // Перенаправляем на страницу логина
    window.location.href = '/login';
  };

  const value = {
    user,
    login,
    logout,
    loading,
    error,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};